"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.form.title.edit': '编辑项目',
    'project.form.title.add': '添加项目',
    'project.form.back': '返回',
    'project.form.color.placeholder': '#007bff',
    'project.form.icon.placeholder': 'fas fa-folder',
};
